module.exports = __webpack_public_path__ + "img/emeet_m2.acd8571f.acd8571f.png";